import {
  Amount,
  Percent,
  PERCENT_DECIMALS,
  PRECISE_DECIMALS,
} from "@silo/types";
import {
  LtvAsset,
  CalculateLtvParams,
  DepositLtvAsset,
  NormalizedLtvAsset,
  NormalizedCalculateLtvParams,
  NormalizedDepositLtvAsset,
} from "./types";
import { shiftDecimal } from "../bigint";
import { NATIVE_DECIMALS } from "./constants";

/**
 * Normalizes all bigint values to have 36 decimals
 */
export function normalizeParams({
  depositAssets,
  debtAssets,
}: CalculateLtvParams): NormalizedCalculateLtvParams {
  return {
    depositAssets: depositAssets.map(normalizeDepositAsset),
    debtAssets: debtAssets.map(normalizeAsset),
  };
}

export function normalizeAsset({
  tokenAddress,
  decimals,
  balance,
  priceNative,
}: LtvAsset): NormalizedLtvAsset {
  return {
    tokenAddress,
    decimals,
    balance: normalizeAmount(balance, decimals),
    priceNative: normalizeNativeAmount(priceNative),
  };
}

export function normalizeDepositAsset(
  asset: DepositLtvAsset
): NormalizedDepositLtvAsset {
  const { maxLtv, lt } = asset;

  return {
    ...normalizeAsset(asset),
    maxLtv: normalizePercent(maxLtv),
    lt: normalizePercent(lt),
  };
}

export function normalizeAmount(value: Amount, decimals: number): bigint {
  return shiftDecimal(value, PRECISE_DECIMALS - decimals);
}

export function normalizeNativeAmount(value: Amount): bigint {
  return shiftDecimal(value, PRECISE_DECIMALS - NATIVE_DECIMALS);
}

export function normalizePercent(value: Percent): bigint {
  return shiftDecimal(value, PRECISE_DECIMALS - PERCENT_DECIMALS);
}
